const EventCategories = {
  ALL: "all",
  WORSHIP_SERVICES: "worship services",
  BIBLE_STUDY: "bible study",
  YOUTH_AND_CHILDRENS_PROGRAMS: "youth and children's programs",
  COMMUNITY_OUTREACH: "community outreach",
  SPECIAL_CELEBRATIONS: "special celebrations",
};

export default EventCategories;
